import React from 'react'

import { useMe } from '../../../contexts/me'

import Loading from '../../loading'

import { Container } from './styles'

import IProps from './props'

const MobileLayout = ({ children }: IProps) => {
  const { me } = useMe()

  if (!me) <Loading />

  return <Container>{children}</Container>
}

MobileLayout.defaultProps = {
  children: null,
}

export default MobileLayout
